module.exports = __webpack_public_path__ + "img/SEN.0966a735.svg";